import { CommonModule } from "@angular/common";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatRadioModule } from "@angular/material/radio";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from "@angular/material/icon";
import { LoginComponent } from "./login/login.component";
import { createTranslateLoader } from "src/app/app.module";
import { AuthRoutingModule } from "./auth-routing.module";
import { MyProfileComponent } from './my-profile/my-profile.component';
import { AccessCodeByTokenComponent } from './access-code-by-token/access-code-by-token.component';
import { GetAccessCodeComponent } from './get-access-code/get-access-code.component';
import { LogOutComponent } from './log-out/log-out.component';

@NgModule({
    declarations: [
        LoginComponent,
        MyProfileComponent,
        AccessCodeByTokenComponent,
        GetAccessCodeComponent,
        LogOutComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        AuthRoutingModule,
        MatDialogModule,
        MatRadioModule,
        MatCheckboxModule,
        ReactiveFormsModule,
        MatIconModule,
        FormsModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            },
        }),

    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AuthModule { }